import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from './BaseComponent';
import { safeJSONParse } from 'helpers/sf_utils';
import { Input, Label, FormGroup } from 'reactstrap';

/**
 * InputComponent is a reusable React component that renders a form component field with an associated label and tooltip.
 * 
 * @param {Object} props - The props for the InputComponent.
 * @param {Object} props.label - An object containing properties related to the label.
 * @param {string} props.label.name - The name of the label.
 * @param {string} props.label.tooltip - The tooltip message for the label.
 * @param {Object} props.component - An object containing properties related to the component field.
 * @param {string} props.component.id - The ID of the component field.
 * @param {string} props.component.name - The name of the component field.
 * @param {string} props.component.type - The type of the component field (default is 'text').
 * @param {Object} props.validation - An object containing form validation properties.
 * @param {Function} props.validation.handleChange - The function to handle component changes.
 * @param {Function} props.validation.handleBlur - The function to handle component blur.
 * @param {Object} props.validation.values - An object containing form values.
 * @param {Object} props.validation.touched - An object indicating whether fields have been touched.
 * @param {Object} props.validation.errors - An object containing validation errors.
 * 
 * @returns {JSX.Element} - A React component that renders an component field with label and tooltip.
 */
const CheckBoxComponent = ({ index, question, onChangeEvent }) => {
    const questionDropDownValues = safeJSONParse(question?.drop_down_values, []);
    const separator = ', '
    const checkBoxValues = (question?.value)?.split(separator) || [];
    const handleOnChange = (value, check_box_values) => {
        const is_value_exist = check_box_values?.includes(value) || false;
        if (is_value_exist) {
            const filtered_check_box_values = check_box_values.filter(item => item !== value);
            onChangeEvent(filtered_check_box_values.join(separator));
            return;
        }
        onChangeEvent([...check_box_values, value].join(separator));
    }
    return (
        <BaseComponent question={question}>
            <div className="quote-funnel-checkbox-content-container">
                {questionDropDownValues.map((questionDropDownValue, index) => (
                    <div key={index} className={index % 2 !== 0 ? 'quote-funnel-checkbox-right-content' : 'quote-funnel-checkbox-left-content'}>
                        <FormGroup check className='d-flex'>
                            <Input
                                type="checkbox"
                                id={`${question?.field_name || ''}_${index}`}
                                name={`${question?.field_name || ''}_${index}`}
                                className="text-left ms-2 mb-3 float-left"
                                style={index % 2 !== 0 ? { float: 'end' } : {}}
                                checked={checkBoxValues.includes(questionDropDownValue.label)}
                                onClick={() => handleOnChange(questionDropDownValue?.label, checkBoxValues)}
                                onChange={() => { }}
                            />
                            <Label check for={`${question?.field_name || ''}_${index}`}>
                                <h5 className="ms-2 d-inline">{questionDropDownValue?.label}</h5>
                            </Label>
                        </FormGroup>
                    </div>
                ))}
            </div>
        </BaseComponent>
    );
}

CheckBoxComponent.propTypes = {
    label: PropTypes.object,
    component: PropTypes.object,
    validation: PropTypes.object,
};

export default CheckBoxComponent;
